import { useIsFocused } from '@react-navigation/native';
import { useIsAppActive } from './useIsAppActive';

export const useIsScreenActive = () => {
    const isAppActive = useIsAppActive();
    const isFocused = useIsFocused();

    return isAppActive && isFocused;
};
